// -------------------------------------------------------------------------------------------------
// Import
// -------------------------------------------------------------------------------------------------

import $ from 'jquery';

// -------------------------------------------------------------------------------------------------
// Variables
// -------------------------------------------------------------------------------------------------

const baseClass = 'form';
// -------------------------------------------------------------------------------------------------
// Classes
// -------------------------------------------------------------------------------------------------

class formSubmit {
  constructor(el) {
    this.el = el;
    this.submitButton = $(el).find('button[type="submit"]');

    this.disableSubmit();
  }

  disableSubmit() {
    this.submitButton.click(function (e) {
      const requiredFields = e.target.closest(`form`);

      if (requiredFields.checkValidity()) {
        setTimeout(function () {
          e.target.classList.add('disabled');
        },100)
      }
    })
  }
}

// -------------------------------------------------------------------------------------------------
// Methods
// -------------------------------------------------------------------------------------------------

function init() {
  $(`.${baseClass}`).each((i, el) => new formSubmit(el));
}

// -------------------------------------------------------------------------------------------------
// Export
// -------------------------------------------------------------------------------------------------

export default {
  init,
};
